<div class="layout-col full">
  <div class="layout-col place-start-start" style="padding-left: 12px">
    <mat-form-field>
      <mat-label>{{ 'schedules.facility' | translate }}</mat-label>
      <elder-select
        name="facilitySchedule"
        appFacilityWorkScheduleSelect
        [facilityId]="facilityId"
        [value]="dummy"
        (valueChange)="onAdd($event)"
      ></elder-select>
    </mat-form-field>

    @if (data.isEmpty) {
      <span>{{ 'shopfloor.workcenters.workSchedules.fallback-msg' | translate }}</span>
    }
  </div>

  <app-work-schedule-manager
    class="flex"
    [data]="data"
    [canAdd]="!!workCenterId"
    (create)="onCreate($event)"
    (deleteAll)="onDeleteAll($event)"
    (duplicate)="onDuplicate($event)"
    (save)="onSave($event)"
  ></app-work-schedule-manager>
</div>
